// src/i18n/es/hmiStaff.js
const hmiStaff = {
    name: 'Personal HMI |||| Personal HMI',

    titles: {
        list: 'Personal HMI',
        create: 'Crear Personal HMI',
        edit: 'Editar Personal HMI',
    },

    fields: {
        name: 'Nombre',
        staffCode: 'Codigo de empleado',
        pin: 'PIN',
        new_pin: 'Nuevo PIN',
        pinStatus: 'Estado PIN',
        isActive: 'Activo',
        hotel: 'Hotel',
    },

    sections: {
        pin: 'Gestión de PIN',
    },

    status: {
        pin_set: 'PIN configurado',
        pin_not_set: 'Sin PIN',
        active: 'Activo',
        inactive: 'Inactivo',
    },

    actions: {
        reset_pin: 'Restablecer PIN',
    },

    filters: {
        search: 'Buscar...',
    },

    notifications: {
        created: 'Personal HMI creado correctamente',
        updated: 'Personal HMI actualizado correctamente',
        pin_reset: 'PIN restablecido correctamente',
    },

    validation: {
        staff_code_format: 'El código debe ser exactamente 2 dígitos',
        pin_format: 'El PIN debe ser exactamente 4 dígitos',
    },

    errors: {
        pin_in_use: 'Este PIN ya está en uso por otro miembro del personal',
        pin_reset_failed: 'Error al restablecer el PIN',
    },

    help: {
        staff_code: 'Código de 2 dígitos que identifica al empleado',
        pin: 'PIN de 4 dígitos para acceso al terminal HMI',
        pin_reset_info: 'Introduzca un nuevo PIN de 4 dígitos para este miembro del personal.',
        login_format: 'Código de acceso al HMI: %{code} + PIN (6 dígitos)',
    },
};

export default hmiStaff;
